var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMealVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.064 20.481c-1.818-.583-4.195-1.476-5.861-.289-2.106 1.499-1.795 4.806-1.35 7.035.522 2.606 2.563 8 6.082 6.87.79-.254.951-.63 1.915-.513.302.037.968.491 1.401.596 3.379.82 5.334-4.494 5.831-7.003.548-2.76.767-6.703-2.657-7.579-1.564-.4-3.086.46-4.598.881h-.764zM21.464 19.992s.64-3.571-2.941-4.482"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.641 10.804h11.91a3.24 3.24 0 013.24 3.24v21.688a3.24 3.24 0 01-3.24 3.24H6.379a3.24 3.24 0 01-3.24-3.24V14.044a3.24 3.24 0 013.24-3.24h11.096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.315 7.221l2.894-2.852c1.842-2.212 5.359-1.757 6.578.85 1.219 2.608-.687 5.598-3.565 5.593l-5.581-.009M17.533 7.282l-2.662-2.921c-1.842-2.212-5.359-1.757-6.578.85-1.219 2.608.687 5.598 3.565 5.593l5.581-.009"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot_x0020_36",
    cx: 21.067,
    cy: 10.804,
    r: 1.445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealVoucher);
export default __webpack_public_path__ + "static/media/MealVoucher.5fb0b6f93cacea720de8b514648a37cd.svg";
export { ForwardRef as ReactComponent };